import React, { useContext, useEffect, useRef } from "react";
import { SwivuViewStateInspectionPopup } from "../../../editors/SwivuViewStateInspectionEditor.jsx";
import { BryntumButton } from "@bryntum/schedulerpro-react";
import useViews from "../../../../hooks/useViews.jsx";
import BryntumContext from "../../../../context/bryntumContext.jsx";
import { EventHelper } from "@bryntum/schedulerpro";
import { EDITOR_KEYS } from "../../../../../other/constants/EditorKeys.jsx";
import { canSaveView } from "../../../../../other/utils/utils.jsx";
import { VIEW_STATE_PIITS_UPDATE_LISTENER } from "../../../../../other/constants/OtherKeys.jsx";

const AppViewStateInspectButton = () => {
  const context = useContext(BryntumContext);
  const { viewManager, editorHandler, project } = context;
  const viewManagerState = useViews();
  const buttonRef = useRef();

  useEffect(() => {
    if (buttonRef.current && viewManagerState?.selectedView) {
      const popup = new SwivuViewStateInspectionPopup();
      const destroyMouseOverListener = EventHelper.on({
        element: buttonRef.current.instance.element,
        mouseover(e) {
          if (viewManager.pageViewsRef) {
            popup.editRecord(viewManagerState.selectedView, context, { hideRemoveButtons: true });
            popup.showBy({ target: e.target });
          }
        },
        mouseout() {
          popup.hide();
        }
      });

      return () => {
        if (!popup.isDestroyed) popup.destroy();
        destroyMouseOverListener();
      };
    }
  }, [viewManagerState, context, viewManager]);

  useEffect(() => {
    if (project && buttonRef.current && viewManagerState) {
      const buttonInstance = buttonRef.current.instance;
      buttonInstance.hidden = !viewManagerState.selectedView.hasPIITS;
      return project.userPreferencesStore.on(VIEW_STATE_PIITS_UPDATE_LISTENER, () => {
        buttonInstance.hidden = !viewManagerState.selectedView.hasPIITS;
      });
    }
  }, [project, viewManagerState])

  return (
    <BryntumButton
      ref={buttonRef}
      cls="relative b-transparent p-0 right-2 bottom-2 text-[#bb6804]"
      icon="fa-light fa-pencil"
      hidden={true}
      onClick={() => {
        if (canSaveView(viewManagerState?.selectedView.viewType)) {
          editorHandler.openEditor(
            EDITOR_KEYS.viewInspectorEditor,
            null,
            { viewRecord: viewManagerState.selectedView },
            { by: "recordType", useExisting: true }
          );
        }
      }}
    />
  );
};

export default AppViewStateInspectButton;
